import React, { createContext, useContext, useState } from 'react';

const AppContext = createContext();

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within AppContextProvider');
  }
  return context;
};

export const AppContextProvider = ({ children }) => {
  const [mqttConnected, setMqttConnected] = useState(false);
  const [activeTrackers, setActiveTrackers] = useState(0);
  const [totalAlerts, setTotalAlerts] = useState(0);
  const [trackers, setTrackers] = useState([]);

  const value = {
    mqttConnected,
    setMqttConnected,
    activeTrackers,
    setActiveTrackers,
    totalAlerts,
    setTotalAlerts,
    trackers,
    setTrackers,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};
